import React, { useEffect, useRef, useState } from 'react';
import Layouts from '../../Layouts';
import ProductList from './ProductList';
import ProductCategories from './ProductCategories';
// import productsData from '../../../sampleData/Productdata';
import line from '../../../Assests/images/line.png'
import radio from '../../../Assests/images/Button.png'
import BannerImg from '../../../Assests/images/Banner.png';
import features from "../../../Assests/images/Features.png"
import ingredients from '../../../Assests/images/natural Ingredients.png'
import Holistic from '../../../Assests/images/Holistic Approach.png'
import Personalized from '../../../Assests/images/Personalized Care.png'
import Balance from '../../../Assests/images/Promotion of Balance.png'
import TimeTested from '../../../Assests/images/Time-Tested Tradition.png'
import Complementary from '../../../Assests/images/Complementary Healthcare.png'
import herbes from '../../../Assests/images/Herbs.png'
import Slider from "react-slick";
import { GrLinkNext, GrLinkPrevious } from "react-icons/gr";
import testimonial1 from '../../../Assests/images/testimonial1.jpeg'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import prev from '../../../Assests/images/Prev.png'
import next from '../../../Assests/images/Next.png'
import { Spin, Empty } from "antd";
import ProductService from '../../../Redux/Services/ProductService';
import { useNavigate } from 'react-router-dom';

const Home = () => {
  const navigate = useNavigate();
  const [currType, setCurrType] = useState('Churnams');
  const [currProductList, setCurrProductList] = useState([]);
  const [productsData, setProducts] = useState([]);
  const [isProductsLoading, setIsProductsLoading] = useState(false);

  const targetRef = useRef(null);

  const scrollToDiv = () => {
    if (targetRef && targetRef.current) {
      targetRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const loadCategoryProducts = async (category) => {
    setIsProductsLoading(true);
    setCurrType(category);
    try {
      if (category === 'AsavamsAristas') {
        const res = await ProductService.ProductList({
          status: 1,
          productCategoryCode: 'Asavas&Aristas',
        });

        if (res?.data && Array.isArray(res.data)) {
          setCurrProductList(res.data);
        } else {
          setCurrProductList([]);
        }
      } else {
        const res = await ProductService.ProductList({
          status: 1,
          productCategoryCode: category,
        });

        if (res?.data && Array.isArray(res.data) && res.data.length > 0) {
          setCurrProductList(res.data);
        } else {
          // Fallback filter
          const fallback = productsData.filter((item) => {
            const catLower = category.toLowerCase();
            const itemCat = String(item.productCategoryCode || item.category || '').toLowerCase();
            const itemName = String(item.name || '').toLowerCase();
            return itemCat.includes(catLower) || itemName.includes(catLower);
          });
          setCurrProductList(fallback);
        }
      }
    } catch (error) {
      console.error('Error loading category products:', error);
      // Fallback on error
      const fallback = productsData.filter(
        (item) => item.productCategoryCode === category
      );
      setCurrProductList(fallback);
    } finally {
      setIsProductsLoading(false);
    }
  };

  const ProductListData = async () => {
    try {
      const payload = { status: 1 };
      const result = await ProductService.ProductList(payload);
      if (result?.data && Array.isArray(result.data)) {
        setProducts(result.data);
      }
    } catch (error) {
      console.error('Error fetching initial product list:', error);
    }
  };

  useEffect(() => {
    ProductListData();
    loadCategoryProducts('Churnams');
  }, []);

  const handleProductCategories = (category) => {
    scrollToDiv();
    loadCategoryProducts(category);
  };


  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
  };

  const CustomPrevArrow = (props) => {
    const { className, style, onClick } = props;
    return (
      <button
        onClick={onClick}
        type="button"
        className="absolute left-[-20px] md:left-[-40px] top-1/2 -translate-y-1/2 z-20 flex items-center justify-center w-10 h-10 rounded-full bg-white border border-amber-200/80 shadow-md hover:bg-amber-50 hover:scale-105 active:scale-95 transition-all cursor-pointer"
        style={{ ...style, display: onClick ? "flex" : "none" }}
      >
        <img src={prev} alt="Prev" className="w-5 h-5" />
      </button>
    );
  };

  const CustomNextArrow = (props) => {
    const { className, style, onClick } = props;
    return (
      <button
        onClick={onClick}
        type="button"
        className="absolute right-[-20px] md:right-[-40px] top-1/2 -translate-y-1/2 z-20 flex items-center justify-center w-10 h-10 rounded-full bg-white border border-amber-200/80 shadow-md hover:bg-amber-50 hover:scale-105 active:scale-95 transition-all cursor-pointer"
        style={{ ...style, display: onClick ? "flex" : "none" }}
      >
        <img src={next} alt="Next" className="w-5 h-5" />
      </button>
    );
  };

  const bottom = {
    dots: true,
    infinite: true,
    speed: 600,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    prevArrow: <CustomPrevArrow />,
    nextArrow: <CustomNextArrow />,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: true,
          dots: true,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: false,
          dots: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          dots: true,
        },
      },
    ],
  };



  return (
    <>
      <Layouts>

        <div className='min-h-screen '>
          <section className='min-h-[85vh] bg-cover bg-no-repeat bg-center py-16 md:py-24 relative flex items-center' style={{ backgroundImage: `url(${BannerImg})` }}>
            {/* Smooth Dark Vignette for Premium Text Contrast */}
            <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/40 to-transparent" />

            <img className='w-full h-2 absolute top-0 z-10' src={line} alt='1' />

            <div className='container mx-auto px-6 md:px-12 relative z-10'>
              <div className="max-w-2xl">
                <h1 className='text-3xl md:text-6xl font-serif font-black text-white leading-tight mb-4'>
                  DISCOVER THE NATURAL<br />
                  <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-200 to-amber-400">
                    PATH TO WELL-BEING
                  </span>
                </h1>

                <p className='text-sm md:text-lg text-gray-200 font-light leading-relaxed text-justify mb-8 max-w-lg'>
                  Embark on a journey of holistic wellness with us. We blend ancient classical wisdom with modern validation to offer personalized remedies. Explore our range of premium Ayurvedic formulations tailored to rejuvenate your mind, body, and spirit.
                </p>

                <div className="flex flex-wrap gap-4">
                  <button
                    onClick={() => navigate('/product')}
                    className="px-8 py-3.5 bg-gradient-to-r from-[#A17A17] to-[#B88E28] hover:from-[#8C6913] hover:to-[#A17A17] text-white font-bold rounded-full shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-0.5 active:translate-y-0 flex items-center gap-3 cursor-pointer group"
                  >
                    <span>Explore Our Products</span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth={2.5}
                      stroke="currentColor"
                      className="w-5 h-5 group-hover:translate-x-1.5 transition-transform duration-200"
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3" />
                    </svg>
                  </button>

                  <button
                    onClick={() => {
                      if (targetRef && targetRef.current) {
                        targetRef.current.scrollIntoView({ behavior: 'smooth' });
                      }
                    }}
                    className="px-6 py-3.5 bg-white/10 hover:bg-white/20 text-white font-semibold rounded-full border border-white/20 hover:border-white/40 transition-all duration-200 flex items-center gap-2 cursor-pointer backdrop-blur-sm"
                  >
                    Learn More
                  </button>
                </div>
              </div>
            </div>

            <img className='w-full h-2 absolute bottom-0 z-10' src={line} alt='1' />
          </section>
          <section className="bg-[#FBF3E6]">
            <div className="container mx-auto md:p-0 p-4 py-[50px] md:py-[90px]">
              <div className="md:flex justify-between items-center">
                <div className="md:w-[60%]">
                  <h1 className="text-3xl font-base text-secondaryColor mb-4">VENKATARAMANA AYURVEDA</h1>
                  <h6 className="text-primaryColor font-medium md:text-2xl text-lg mb-2">Who we are</h6>
                  <p className=" text-justify mb-4 md:w-[80%]">Venkataramana Ayurveda harnesses Ayurvedic wisdom for comprehensive wellness. With experienced practitioners and authentic therapies, we empower individuals to achieve balance and vitality naturally. Where ancient wisdom meets modern wellness, guiding you to a harmonious life through the transformative power of Ayurveda.
                  </p>
                  <div >
                    <ul className="md:grid grid-cols-2 gap-2 ">
                      <li className="flex gap-2  items-center"><img className='h-4 w-4 mt[3px]' src={radio} alt='/' />
                        Premium Branding</li>
                      <li className="flex gap-2  items-center"> <img className='h-4 w-4 mt[3px]' src={radio} alt='/' /> Guaranteeing Punctual Delivery</li>
                      <li className="flex gap-2  items-center"> <img className='h-4 w-4 mt[3px]' src={radio} alt='/' /> 100% Natural</li>
                      <li className="flex gap-2  items-center"> <img className='h-4 w-4 mt[3px]' src={radio} alt='/' /> Ensuring Rigorous Quality Assurance</li>
                    </ul>
                  </div>

                </div>
                <div className="md:w-[40%] md:h-[350px] md:p-0 p-4">
                  <img src={herbes} alt="" className="w-full h-full object-contain" />
                </div>
              </div>
            </div>
          </section>
          <ProductCategories
            currType={currType}
            handleProductCategories={handleProductCategories}
            isLoading={isProductsLoading}
          />

          <section ref={targetRef} className="bg-[#FAF8F5] py-12 px-4 transition-all duration-300">
            <div className="container mx-auto">
              {isProductsLoading ? (
                <div className="flex flex-col justify-center items-center py-20 min-h-[350px] bg-white rounded-3xl border border-amber-100/80 shadow-sm">
                  <Spin size="large" />
                  <p className="mt-5 text-[#866100] font-bold text-base tracking-wide animate-pulse">
                    Fetching {currType === 'AsavamsAristas' ? 'Asavams & Aristas' : currType}...
                  </p>
                  <p className="text-gray-400 text-xs mt-1">Authentic Classical Formulations</p>
                </div>
              ) : currProductList && currProductList.length > 0 ? (
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 md:gap-8 justify-items-center animate-fadeIn">
                  <ProductList currProductList={currProductList} />
                </div>
              ) : (
                <div className="bg-white rounded-3xl border border-amber-100 p-12 text-center my-4 shadow-sm">
                  <Empty
                    description={
                      <div className="mt-2">
                        <h3 className="text-lg font-bold text-gray-800">No products available</h3>
                        <p className="text-gray-500 text-sm mt-1">
                          No products found in this category right now.
                        </p>
                      </div>
                    }
                  />
                </div>
              )}
            </div>
          </section>
          <section className="relative bg-secondaryColor">
            <img className=' w-full h-2 absolute top-0' src={line} alt='1' />
            <div className="container mx-auto text-center py-20">
              <h1 className="text-2xl text-textWhite font-medium mb-2">OUR FEATURES</h1>
              <p className="md:text-2xl text-lg text-primaryColor font-base">Why Venkataramana Ayurveda?</p>
            </div>
            <img className=' w-full h-2 absolute bottom-0' src={line} alt='1' />
          </section>
          <section className='min-h-[85vh]  bg-cover bg-no-repeat bg-center py-[50px] md:p-0 p-4 relative' style={{ backgroundImage: `url(${features})` }}>
            <div className="container mx-auto">
              <div className="md:w-[80%] md:text-xl text-lg text-textWhite font-base">
                <p className=''>Ayurveda, a traditional system of medicine originating from ancient India, offers a a holistic approach to health and wellness. There are several reasons why people choose to use Ayurvedic products:</p>
              </div>
              <div className="md:px-10 my-10">
                <ul className="text-textWhite font-base  mt-10 flex flex-col gap-2">
                  <li className="md:flex gap-4  items-center "><img className='md:w-8 w-12 md:h-8 h-12' src={ingredients} alt='/' />
                    <span className='font-normal md:w-[86%]  text-[16px]'>Natural Ingredients: Ayurvedic products s are typically formulated using natural ingredients such as herbis, roots, flowers, and oils. This emphasis on natural ingredients is appealing to those who prefer to avoid synthetic chemicals and additives.</span>
                  </li>
                  <li className="md:flex gap-4  items-center "> <img className='md:w-8 w-12 md:h-8 h-12' src={Holistic} alt='/' />
                    <span className='font-normal md:w-[86%] text-[16px]'>Holistic Approach: Ayurveda considers the interconnectedness of the body, mind, and spirit in achieving overall health and wellurvedic products often address not just the symptoms of a condition but also its underlying causes providing a holistic approach to health.</span></li>
                  <li className="md:flex gap-4  items-center "><img className='md:w-8 w-12 md:h-8 h-12' src={Personalized} alt='/' />
                    <span className='font-normal md:w-[86%] text-[16px]'> Personalized Care: Ayurveda recognizes that each individual is unique, and therefore, treatments and products are often tollored to suit a person's specific constitution (dosha) and needs. This personalized approach is appealing to those seeking customized healthcare solutions.</span></li>
                  <li className="md:flex gap-4  items-center "><img className='md:w-8 w-12 md:h-8 h-12' src={TimeTested} alt='/' />
                    <span className='font-normal md:w-[86%] text-[16px]'>Time-Tested Tradition: Ayurveda has a rich history spanning thousands of years and has been passed down through generations. Many people trust Ayurvedic remedies due to their long history of use and the wealth of empirical evidence supporting their efficacy.</span></li>
                  <li className="md:flex gap-4  items-center "><img className='md:w-8 w-12 md:h-8 h-12' src={Balance} alt='/' />
                    <span className='font-normal md:w-[86%] text-[16px]'>Promotion of Balance: Ayurveda aims to restore balance to the body and mind by addressing imbalances in the doshas (Vata, Pitta, and Kapha). Ayurvedic products are formulated to help bring the doshas back into harmony, theretry promoting overall health and vitality.</span></li>
                  <li className="md:flex gap-4  items-center "><img className='md:w-8 w-12 md:h-8 h-12' src={Complementary} alt='/' />
                    <span className='font-normal md:w-[86%] w-24 text-[16px]'>Complementary Healthcare: Many people use Ayurvedic products alongside conventional medical treatments as a complementary approach to health and wellness. Ayurveda can often provide support for various health conditions and help manage symptoms.</span></li>
                  <li></li>
                </ul>
              </div>
              <div className="md:w-[80%] text-lg text-textWhite font-base">
                <p className=''>Overall, the use of Ayurvedic products aligns with a growing trend towards natural, holistic, and personalized approaches to health and wellness.</p>
              </div>
            </div>


          </section>
          <section className='bg-[#FBF3E6] py-16 overflow-hidden'>
            <div className="container mx-auto px-6 md:px-12 relative">
              <div className="text-center mb-12">
                <span className="text-xs uppercase tracking-widest font-bold text-[#A17A17]">
                  Real Customer Experiences
                </span>
                <h2 className="text-3xl md:text-4xl font-serif font-bold text-gray-900 mt-1">
                  Testimonials
                </h2>
                <div className="w-16 h-1 bg-[#A17A17] mx-auto mt-3 rounded-full" />
              </div>

              <div className="relative px-2">
                <Slider {...bottom}>
                  <div>
                    <div className="bg-white rounded-3xl p-6 mx-3 shadow-md hover:shadow-xl transition-shadow border border-amber-100 flex flex-col justify-between min-h-[380px]">
                      <div>
                        <div className="mb-4 flex justify-center">
                          <img
                            src={testimonial1}
                            alt="Shita Bagchi"
                            className="h-24 w-24 rounded-full object-cover shadow-md border-2 border-amber-100"
                          />
                        </div>
                        <p className="text-sm md:text-base leading-relaxed text-gray-600 text-center italic h-[160px] overflow-y-auto pr-1 select-none" id="unquie-scroll">
                          "I live on the outskirts of Kundhei and last week, I was
                          looking for medicine unavailable at any nearby local
                          pharmacy. It was when one of my neighbours suggested Venkataramana Ayurveda. Recently I contacted their e-clinic in
                          my area for teleconsultation. Their team helped me
                          teleconsult with the leading heart specialist."
                        </p>
                      </div>
                      <div className="text-center mt-4 pt-4 border-t border-gray-100">
                        <p className="text-base font-bold text-gray-800 mb-0">
                          Shita Bagchi
                        </p>
                        <p className="text-xs text-[#A17A17] font-semibold">Bhubaneswar</p>
                      </div>
                    </div>
                  </div>

                  <div>
                    <div className="bg-white rounded-3xl p-6 mx-3 shadow-md hover:shadow-xl transition-shadow border border-amber-100 flex flex-col justify-between min-h-[380px]">
                      <div>
                        <div className="mb-4 flex justify-center">
                          <img
                            src={testimonial1}
                            alt="Balaji R."
                            className="h-24 w-24 rounded-full object-cover shadow-md border-2 border-amber-100"
                          />
                        </div>
                        <p className="text-sm md:text-base leading-relaxed text-gray-600 text-center italic h-[160px] overflow-y-auto pr-1 select-none" id="unquie-scroll">
                          "I live on the outskirts of Kundhei and last week, I was
                          looking for medicine unavailable at any nearby local
                          pharmacy. It was when one of my neighbours suggested Venkataramana Ayurveda. Recently I contacted their e-clinic in
                          my area for teleconsultation. Their team helped me
                          teleconsult with the leading heart specialist."
                        </p>
                      </div>
                      <div className="text-center mt-4 pt-4 border-t border-gray-100">
                        <p className="text-base font-bold text-gray-800 mb-0">
                          Balaji R.
                        </p>
                        <p className="text-xs text-[#A17A17] font-semibold">Chennai</p>
                      </div>
                    </div>
                  </div>

                  <div>
                    <div className="bg-white rounded-3xl p-6 mx-3 shadow-md hover:shadow-xl transition-shadow border border-amber-100 flex flex-col justify-between min-h-[380px]">
                      <div>
                        <div className="mb-4 flex justify-center">
                          <img
                            src={testimonial1}
                            alt="Preethi K."
                            className="h-24 w-24 rounded-full object-cover shadow-md border-2 border-amber-100"
                          />
                        </div>
                        <p className="text-sm md:text-base leading-relaxed text-gray-600 text-center italic h-[160px] overflow-y-auto pr-1 select-none" id="unquie-scroll">
                          "Venkataramana Ayurveda has completely transformed my approach to healthcare. The quality of classical medicines is unmatched, and they are delivered directly with rigorous quality assurance. Highly recommend their consultations!"
                        </p>
                      </div>
                      <div className="text-center mt-4 pt-4 border-t border-gray-100">
                        <p className="text-base font-bold text-gray-800 mb-0">
                          Preethi K.
                        </p>
                        <p className="text-xs text-[#A17A17] font-semibold">Bhubaneswar</p>
                      </div>
                    </div>
                  </div>

                  <div>
                    <div className="bg-white rounded-3xl p-6 mx-3 shadow-md hover:shadow-xl transition-shadow border border-amber-100 flex flex-col justify-between min-h-[380px]">
                      <div>
                        <div className="mb-4 flex justify-center">
                          <img
                            src={testimonial1}
                            alt="Sharmila S."
                            className="h-24 w-24 rounded-full object-cover shadow-md border-2 border-amber-100"
                          />
                        </div>
                        <p className="text-sm md:text-base leading-relaxed text-gray-600 text-center italic h-[160px] overflow-y-auto pr-1 select-none" id="unquie-scroll">
                          "I live on the outskirts of Kundhei and last week, I was
                          looking for medicine unavailable at any nearby local
                          pharmacy. It was when one of my neighbours suggested Venkataramana Ayurveda. Recently I contacted their e-clinic in
                          my area for teleconsultation."
                        </p>
                      </div>
                      <div className="text-center mt-4 pt-4 border-t border-gray-100">
                        <p className="text-base font-bold text-gray-800 mb-0">
                          Sharmila S.
                        </p>
                        <p className="text-xs text-[#A17A17] font-semibold">Hyderabad</p>
                      </div>
                    </div>
                  </div>
                </Slider>
              </div>
            </div>
          </section>
        </div>
      </Layouts>

    </>
  );
};

export default Home;